import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { IconButton } from '@totalsoft/rocket-ui';
import { FilterFramesOutlined } from '@mui/icons-material';
import { ServiceContext } from 'providers/ServiceProvider';
import { Origination } from 'constants/contexts';

const HeaderLinks = ({ onToggleModal }) => {
  const { t } = useTranslation();
  const [activeService] = useContext(ServiceContext);

  return (
    <>
      <span>
        {activeService?.route === Origination.serviceRoute && (
          <IconButton fontSize='medium' color='transparent' tooltip={t('Tooltips.Test')} onClick={() => onToggleModal()}>
            <FilterFramesOutlined color='primary' />
          </IconButton>
        )}
      </span>
    </>
  );
};

HeaderLinks.propTypes = {
  onToggleModal: PropTypes.func.isRequired,
  showModal: PropTypes.bool,
  onCloseModal: PropTypes.func.isRequired
};
export default HeaderLinks;
